module.exports = __webpack_public_path__ + "img/face_shape_male_rect.162457e6.png";